var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93 518 c-30 -48 -33 -67 -33 -222 0 -113 4 -166 12 -174 17 -17 479 -17 496 0 8 8 12 61 11 178 0 138 -3 170 -18 195 l-18 30 -221 3 c-170 2 -222 -1 -229 -10z m447 -18 c0 -6 -80 -10 -220 -10 -140 0 -220 4 -220 10 0 6 80 10 220 10 140 0 220 -4 220 -10z m20 -34 c0 -10 -226 -166 -240 -166 -13 0 -205 131 -234 161 -6 5 82 9 232 9 133 0 242 -2 242 -4z m-354 -113 c55 -40 107 -73 114 -73 7 0 59 33 114 73 56 40 107 76 114 81 9 6 12 -27 12 -148 l0 -156 -240 0 -240 0 0 156 c0 121 3 154 13 148 6 -5 57 -41 113 -81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 200 c0 -5 18 -10 40 -10 22 0 40 5 40 10 0 6 -18 10 -40 10 -22 0 -40 -4 -40 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 170 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 170 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 170 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 160 c0 -5 23 -10 50 -10 28 0 50 5 50 10 0 6 -22 10 -50 10 -27 0 -50 -4 -50 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail2);
export default __webpack_public_path__ + "static/media/mail_2.b9cc5ca69ad2d767dc571fa183e5c943.svg";
export { ForwardRef as ReactComponent };